import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

const formatDate = (date) => {
    return new Date(date).toISOString().split('T')[0]
}

export const usePortfolioManagerStore = defineStore('portfolioManagerStore', () => {
    const today = formatDate(new Date())
    const endOfYear = formatDate(new Date(new Date().getFullYear(), 11, 31))
    // Default - get overwritten
    const dateRange = ref([today, endOfYear])
    const allowPruning = ref(false)

    const resetState = () => {
        dateRange.value = [today, endOfYear]
        allowPruning.value = false
    }

    return {
        dateRange,
        resetState,
        allowPruning,
    }
})
